import React, {  useRef, useState } from 'react';

import { FormControl, Select, MenuItem } from '@mui/material';
import { useSnackbar } from '../SnackBar';

import { useProgressBar } from '../ProgressBar';
import { useNavigate } from 'react-router-dom';
import { usePartnerContext } from '../../components/Context/PartnerContext';
import { useBranchContext } from '../../components/Context/BranchContext';

const AddProduct = () => {
    const nameRef = useRef();
    const manufacturerRef = useRef();
    const modelRef = useRef();
    const yearRef = useRef();
    const priceRef = useRef();
    const quantityRef = useRef();
    const reorderRef = useRef();

    const [inStock, setInStock] = useState(true);
    const [isQuickSelect, setIsQuickSelect] = useState(false);
    const [categoryId, setCategoryId] = useState('');
    const [branchId, setBranchId] = useState('');
    const navigate = useNavigate();
    const { showSnackbar } = useSnackbar();
    const { showProgress } = useProgressBar();
    const formRef = useRef();
    const { ProductCategory,AddNewProduct } = usePartnerContext();
    const { branches } = useBranchContext();

   
   

    const handleSubmit = async () => {
        if (!nameRef.current.value || !categoryId || !branchId || !priceRef.current.value) {
            showSnackbar("Please fill required fields", "error");
            return;
        }

        showProgress(true);
        try {
            const payload = {
                productName: nameRef.current.value.trim(),
                categoryId: parseInt(categoryId),
                manufacturer: manufacturerRef.current.value.trim(),
                model: modelRef.current.value.trim(),
                year: parseInt(yearRef.current.value) || 0,
                price: parseFloat(priceRef.current.value),
                inStock: inStock,
                isQuickSelect: isQuickSelect,
                branchId: parseInt(branchId),
                quantityInStock: parseInt(quantityRef.current.value),
                reorderLevel: parseInt(reorderRef.current.value)
            };

            const result = await AddNewProduct(payload);
            showSnackbar("Product added successfully", "success");
            navigate("/products");
        } catch (err) {
            showSnackbar("Failed to add product", "error");
            console.error(err);
        } finally {
            showProgress(false);
        }
    };

    return (
        <main id="main" className="main">
            <div className="pagetitle">
                <h1>Add Product</h1>
                <nav>
                    <ol className="breadcrumb">
                        <li className="breadcrumb-item"><a href="/products">Products</a></li>
                        <li className="breadcrumb-item active">New Product</li>
                    </ol>
                </nav>
            </div>

            <section className="section">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="card">
                            <div className="card-body">
                                <h5 className="card-title">Product Details</h5>
                                <form ref={formRef}>
                                    <div className="row mb-3">
                                        <label className="col-sm-2 col-form-label">Product Name</label>
                                        <div className="col-sm-6">
                                            <input type="text" className="form-control" ref={nameRef} />
                                        </div>
                                    </div>

                                    <div className="row mb-3">
                                        <label className="col-sm-2 col-form-label">Category</label>
                                        <div className="col-sm-6">
                                            <FormControl fullWidth>
                                                <Select
                                                    value={categoryId}
                                                    onChange={(e) => setCategoryId(e.target.value)}
                                                >
                                                    {Array.isArray(ProductCategory) && ProductCategory.map((cat) => (
                                                        <MenuItem key={cat.id} value={cat.id}>{cat.name}</MenuItem>
                                                    ))}
                                                </Select>
                                            </FormControl>
                                        </div>
                                    </div>

                                    <div className="row mb-3">
                                        <label className="col-sm-2 col-form-label">Manufacturer</label>
                                        <div className="col-sm-6">
                                            <input type="text" className="form-control" ref={manufacturerRef} />
                                        </div>
                                    </div>

                                    <div className="row mb-3">
                                        <label className="col-sm-2 col-form-label">Model</label>
                                        <div className="col-sm-6">
                                            <input type="text" className="form-control" ref={modelRef} />
                                        </div>
                                    </div>

                                    <div className="row mb-3">
                                        <label className="col-sm-2 col-form-label">Year</label>
                                        <div className="col-sm-6">
                                            <input type="number" className="form-control" ref={yearRef} />
                                        </div>
                                    </div>

                                    <div className="row mb-3">
                                        <label className="col-sm-2 col-form-label">Price</label>
                                        <div className="col-sm-6">
                                            <input type="number" className="form-control" ref={priceRef} />
                                        </div>
                                    </div>

                                    <div className="row mb-3">
                                        <label className="col-sm-2 col-form-label">Branch</label>
                                        <div className="col-sm-6">
                                            <FormControl fullWidth>
                                                <Select
                                                    value={branchId}
                                                    onChange={(e) => setBranchId(e.target.value)}
                                                >
                                                    {Array.isArray(branches) && branches.map((branch) => (
                                                        <MenuItem key={branch.id} value={branch.id}>{branch.name}</MenuItem>
                                                    ))}
                                                </Select>
                                            </FormControl>
                                        </div>
                                    </div>

                                    <div className="row mb-3">
                                        <label className="col-sm-2 col-form-label">Quantity In Stock</label>
                                        <div className="col-sm-6">
                                            <input type="number" className="form-control" ref={quantityRef} />
                                        </div>
                                    </div>

                                    <div className="row mb-3">
                                        <label className="col-sm-2 col-form-label">Change Frequency(KM)</label>
                                        <div className="col-sm-6">
                                            <input type="number" className="form-control" ref={reorderRef} />
                                        </div>
                                    </div>

                                    <div className="row mb-3">
                                        <label className="col-sm-2 col-form-label">In Stock</label>
                                        <div className="col-sm-6 mt-2">
                                            <input
                                                type="checkbox"
                                                checked={inStock}
                                                onChange={(e) => setInStock(e.target.checked)}
                                            /> Available
                                        </div>
                                    </div>

                                    <div className="row mb-3">
                                        <label className="col-sm-2 col-form-label">Quick Select</label>
                                        <div className="col-sm-6 mt-2">
                                            <input
                                                type="checkbox"
                                                checked={isQuickSelect}
                                                onChange={(e) => setIsQuickSelect(e.target.checked)}
                                                id="productQuickSelect"
                                            />{' '}
                                            <label htmlFor="productQuickSelect">Show as quick select in partner app</label>
                                        </div>
                                    </div>

                                    <div className="col-12 d-flex justify-content-end align-items-end">
                                        <button type="button" className="btn btn-primary px-3 py-2" onClick={handleSubmit}>
                                            Save
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </main>
    );
};

export default AddProduct;
